import { BookingMethods, IBooking, ToastType } from 'shared-types/SharedTypes';
import moment from 'moment';
import DateUtilsService from 'external-services/date-utils-service';
import { rootDisplayActions } from 'app/reducers/display/slice';
import { AppDispatch } from 'appRoot/Store';
import { bookingStatusType } from 'shared-types/bookingStatusTypes';

export const getDuplicateBookingSubText = (newBooking: IBooking, booking: IBooking) => {
  return `${getFullNameFromBooking(newBooking)}: ${getTimeFromBooking(
    newBooking
  )} \n${getFullNameFromBooking(booking)}: ${getTimeFromBooking(booking)}`;
};
const getFullNameFromBooking = (booking: IBooking) => {
  return booking.firstName ? `${booking.firstName} ${booking.lastName}` : booking.lastName;
};
const getTimeFromBooking = (booking: IBooking) => {
  return moment(booking.time).format('hh:mm A');
};

export function checkDuplicateBooking(
  newBooking: IBooking,
  updatedBookingsList: IBooking[],
  dispatch: any,
  onSuccess: (booking: IBooking) => void
): void {
  let checkDuplicate = false;

  if (newBooking.status.statusType === bookingStatusType.cancelled || // filters out cancelled and no shows
    !newBooking?.tables.length // filters out standby and waitlist
  ) {
    return;
  }

  updatedBookingsList.forEach((booking) => {
    const isSameCustomer = booking.customerId && newBooking.customerId && booking.customerId === newBooking.customerId;
    if (
      isSameCustomer &&
      booking._id !== newBooking._id &&
      (newBooking.method === BookingMethods.internet) &&
      !checkDuplicate
    ) {
      checkDuplicate = true;
      const type = DateUtilsService.isDateSame(newBooking.time, booking.time, true)
        ? ToastType.warning
        : ToastType.success;
      dispatch(
        rootDisplayActions.showToastClean({
          message: 'Multiple bookings by customer',
          type,
          subText: getDuplicateBookingSubText(newBooking, booking),
          actionText: 'View',
          onAction: () => {
            onSuccess(newBooking);
          },
          handleClose: () => {
            // do nothing
          },
        })
      );
    }
  });
}